import { Button, Icon, Stack, VStack } from "@chakra-ui/react";
import Footer from "_components/Footer";
import { logEvent } from "helpers/analytics";
import React from "react";
import { Helmet } from "react-helmet";
import ConnectionCircle from "../../assets/connection-circle.png";
import OnlinePresenceCircle from "../../assets/online-presence-circle.png";
import BusinessCircle from "../../assets/business-circle.png";
import AirplaneCircle from "../../assets/airplane-circle.png";
import SampleProPortfolio from "../../assets/sample-pro-portfolio.png";
import CreateProfileStep from "../../assets/create-profile-step.png";
import CustomiseWebsiteStep from "../../assets/customise-your-website-step.png";
import ShareSiteStep from "../../assets/share-your-website-step.png";
import Asterisk from "../../assets/asterisk.png";
import { FaArrowRight } from "react-icons/fa";
import SkilledWorkersFAQs from "_components/skilled-workers-landing-pages/SkilledWorkersFAQs";
import { portfolioFAQs } from "./faqs";

export function PortfolioLandingPage() {
  const handleCTAClick = () => {
    logEvent("portfolio_landing_page_cta_click");

    window.open(`${process.env.REACT_APP_PRO_APPLICATION_URL}`, "_blank");
  };
  return (
    <>
      <Helmet>
        <title>
          LaborPass - Build a professional portfolio that sets you apart
        </title>
      </Helmet>
      <VStack spacing={0} w={"full"}>
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-0 w-full">
          <div className="bg-[#63A7CE] w-full px-3 lg:px-20 py-8 lg:py-16 flex flex-col gap-8 lg:gap-12 border-[#121212] border-r-[1px] border-b-[1px]">
            <div className="flex flex-col gap-4 lg:gap-6">
              <h1 className="w-[90%] lg:w-[90%] text-3xl lg:text-6xl font-bold text-[#121212] leading-[42px] lg:leading-[72px]">
                Build a professional <br className="block lg:hidden" />{" "}
                portfolio that <br className="hidden lg:block" /> sets
                <br className="block lg:hidden" /> you apart
              </h1>
              <p className="text-lg lg:text-2xl text-[#121212] w-[100%] lg:w-[90%]">
                Create a stylish portfolio or microsite to showcase your
                incredible work and services with LaborPass and build the
                credibility you need to secure high-paying gigs. No code
                required!
              </p>
            </div>
            <Button
              backgroundColor={"#0E1E27"}
              color={"#FEFEFE"}
              paddingY={{
                base: 6,
                lg: 10,
              }}
              w={"60%"}
              fontSize={{
                base: 15,
                lg: 18,
              }}
              rightIcon={
                <Icon
                  as={FaArrowRight}
                  w={{
                    base: 4,
                    lg: 5,
                  }}
                  h={5}
                  ml={2}
                  className="animate-wiggle"
                />
              }
              onClick={() => handleCTAClick()}
            >
              Get started for free
            </Button>
            <div className="flex gap-3 items-center">
              <p className="text-xl lg:text-2xl text-[#121212] lg:leading-8">
                Unique Link
              </p>
              <img className="w-[16px] h-[16px]" src={Asterisk} alt="asterik" />
              <p className="text-xl lg:text-2xl text-[#121212] lg:leading-8">
                99.99% Uptime
              </p>
            </div>
          </div>
          <div className="bg-[#C1DCEB] border-[#121212] border-b-[1px] flex items-center justify-center py-12 lg:py-16">
            <div className="w-[90%] lg:w-[502px] h[360px] lg:h-[470px]">
              <img
                className="w-full h-full"
                src={SampleProPortfolio}
                alt="sample LaborPass"
              />
            </div>
          </div>
        </section>
        <section className="flex flex-col gap-0 w-full">
          <div className="w-full grid grid-cols-1 lg:grid-cols-4 gap-0 border-[#121212] border-t-[1px] border-b-[1px]">
            <div className="py-4 lg:py-8 px-3 lg:px-20 border-[#121212] lg:border-r-[1px] border-b-[1px] lg:border-b-0   flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img src={OnlinePresenceCircle} alt="helmet icon" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  Boost your online presence
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Stand out with a sleek, custom-designed and SEO-friendly
                  website that reflects your expertise.
                </p>
              </div>
            </div>

            <div className="py-4 lg:py-8 px-3 lg:px-20 border-[#121212] lg:border-r-[1px] lborder-b-[1px] lg:border-b-0    flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img src={BusinessCircle} alt="gear icon" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  Showcase your experience
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Showcase verified job history, ratings, and certifications to
                  build credibility.
                </p>
              </div>
            </div>

            <div className="py-4 lg:py-8 px-3 lg:px-20 border-[#121212] lg:border-r-[1px] border-b-[1px] lg:border-b-0  flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img src={ConnectionCircle} alt="check mark icon" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  Attract more clients
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Make it simple for clients to reach out for jobs—no middlemen.
                </p>
              </div>
            </div>

            <div className="py-4 lg:py-8 px-3 lg:px-20 lg:border-[#121212] border-b-[1px] lg:border-b-0  flex flex-col items-start gap-6">
              <div className="w-14 h-14 lg:w-24 lg:h-24 rounded-full">
                <img src={AirplaneCircle} alt="airplane icon" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[14px] lg:text-[24px] font-semibold text-[#212121]">
                  Share with ease
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Share your unique website link on WhatsApp, email, or social
                  media to increase visibility.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="w-full flex flex-col gap-4 lg:gap-8 border-[#121212] border-b-[1px]">
          <div className="px-3 lg:px-20 py-10 lg:py-16 flex flex-col gap-8 border-[#121212] border-b-[1px]">
            <div className="flex flex-col gap-4 w-full items-center justify-center">
              <h2 className="text-xl lg:text-5xl lg:w-[40%] text-[#122A38] font-medium lg:leading-[56px] text-center">
                Build a LaborPass <br /> in a few steps
              </h2>
            </div>
          </div>
          <div className="w-full py-8 lg:px-20 flex flex-col lg:flex-row gap-12 lg:gap-6">
            <div className="px-3 lg:px-0 pb-8 lg:pb-0 border-[#121212] border-b-[1px] lg:border-b-0 w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img
                  src={CreateProfileStep}
                  alt="create profile representation"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Create your profile
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  {`Sign up on LaborHack and fill in your biodata and contact details.`}
                </p>
              </div>
            </div>

            <div className="px-3 lg:px-0 pb-8 lg:pb-0 border-[#121212] border-b-[1px] lg:border-b-0 w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img
                  src={CustomiseWebsiteStep}
                  alt="customise LaborPass reprsentation"
                />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Customise your LaborPass
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Upload certifications, licences, or awards, provide a list of
                  completed jobs with client feedback and budgets (optional).
                  Add photos or videos of your work to impress potential
                  clients.
                </p>
              </div>
            </div>

            <div className="px-3 lg:px-0 w-full lg:w-1/3 flex flex-col items-start gap-6">
              <div className="w-fit h-fit">
                <img src={ShareSiteStep} alt="share your site representation" />
              </div>
              <div className="flex flex-col gap-4">
                <h4 className="text-[16px] lg:text-[24px] font-medium lg:font-semibold text-[#212121]">
                  Share your LaborPass
                </h4>
                <p className="text-[13px] lg:text-[22px] font-normal text-[#464646]">
                  Get a unique link to your LaborPass and share it via WhatsApp,
                  email, or social media.
                </p>
              </div>
            </div>
          </div>
        </section>
        <SkilledWorkersFAQs items={portfolioFAQs} />
        <section className="px-6 py-14 lg:py-16 w-full bg-[#FBE2DE] flex flex-col text-center items-center gap-6 lg:gap-10">
          <div className="w-full lg:w-[40%] flex flex-col items-center gap-4 lg:gap-6">
            <h3 className="text-[20px] lg:text-[48px] font-medium text-[#2F1612] lg:leading-[56px]">
              {`Don't just tell clients what you can do—show them`}
            </h3>
            <p className="text-base lg:text-2xl text-[#2F1612] lg:leading-8 lg:px-12">
              Build your LaborPass to showcase your work, earn trust, and get
              that money.
            </p>
          </div>
          <div className="w-full">
            <Button
              backgroundColor={"#FEFEFE"}
              color={"#2F1612"}
              paddingY={{
                base: 6,
                lg: 10,
              }}
              w={{
                base: "60%",
                lg: "25%",
              }}
              paddingX={{
                base: 8,
                lg: 10,
              }}
              fontSize={{
                base: 15,
                lg: 22,
              }}
              rightIcon={
                <Icon
                  as={FaArrowRight}
                  w={{
                    base: 4,
                    lg: 5,
                  }}
                  h={5}
                  ml={2}
                  className="animate-wiggle"
                />
              }
              onClick={() => handleCTAClick()}
            >
              Get started for free
            </Button>
          </div>
        </section>
      </VStack>
      <Footer />
    </>
  );
}
